import { useState, useEffect, useCallback } from "react";
import "./ScrollButtons.css";

export default function ScrollButtons() {
  const [showTop, setShowTop] = useState(false);
  const [showBottom, setShowBottom] = useState(true);

  const update = useCallback(() => {
    const scrollY = window.scrollY;
    const docH = document.documentElement.scrollHeight - window.innerHeight;

    setShowTop(scrollY > 300);
    // Hide "go to bottom" when already within 100px of bottom
    setShowBottom(docH > 0 && scrollY < docH - 100);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", update, { passive: true });
    update(); // run once on mount
    return () => window.removeEventListener("scroll", update);
  }, [update]);

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  // const scrollToBottom = () =>
  //   window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });

  return (
    <div className="scroll-btn-group" aria-label="Page navigation">
      {showTop && (
        <button
          className="scroll-btn scroll-btn--top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          title="Back to top"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
      {/* {showBottom && (
        <button
          className="scroll-btn scroll-btn--bottom"
          onClick={scrollToBottom}
          aria-label="Scroll to bottom"
          title="Go to bottom"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      )} */}
    </div>
  );
}
